import React, { Component } from 'react'
import Button from 'components/button/button'
import { deleteItem, deleteTodo, deleteFile, deleteFileVersion } from 'state/actions'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

class ModalLeave extends Component {
	constructor(props){
		super(props)

		this.item = {}

		this.state = {
			checkOptionStatus: false
		}
	}

	doAction(){
        this.props.setLoading(true)
        
        this.successCallback()
	}

	successCallback = _ => {
		this.props.setLoading(false)
		this.props.closeCallback()
	}

	componentWillMount = _ => {

	}

	render() {
		return(
			<div>
				<div className={'modal-task borders'}>
                    <h3>
                        "{ this.props.data.name }"
                    </h3>
				</div>
				<Button size={'big'} level={'high'} callback={_ => {this.doAction()}} label={'Yep'} icon={'check'} />
				<Button size={'big'} level={'low'} callback={this.props.closeCallback} label={'Cancel'} />
			</div>
		);
	}
}

export default withRouter(connect(null, {  })(ModalLeave))



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-leave.jsx